import React from 'react';
import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';

const resolveImage = (img) => {
  if (!img) return null;
  if (typeof img === 'string') return img;
  if (Array.isArray(img)) return resolveImage(img[0]);
  if (img['@id']) {
    return `${flattenToAppURL(img['@id'])}/@@images/image/great`;
  }
  return null;
};

// Card DS: imagem + parágrafo (sem caixa, sem "Saiba mais").
const Card = ({ item }) => {
  const imageUrl = resolveImage(item.image) || item.imageUrl || null;
  const Inner = (
    <>
      <div
        className="ag-institutional__card-img"
        style={imageUrl ? { backgroundImage: `url('${imageUrl}')` } : {}}
        aria-hidden="true"
      />
      <p className="ag-institutional__card-text">{item.title}</p>
    </>
  );
  return item.href ? (
    <UniversalLink href={item.href} className="ag-institutional__card">
      {Inner}
    </UniversalLink>
  ) : (
    <div className="ag-institutional__card">{Inner}</div>
  );
};

const InstitutionalView = ({ data }) => {
  const cards = data.cards || [];
  const featuredImg = resolveImage(data.featuredImage) || data.featuredImageUrl || null;
  const hasFeaturedText =
    data.badge || data.title || data.description || (data.ctaHref && data.ctaLabel);

  return (
    <section className="ag-institutional">
      <div className="ag-institutional__inner">
        {hasFeaturedText && (
          <div
            className={`ag-institutional__featured${featuredImg ? ' ag-institutional__featured--has-image' : ''}`}
          >
            {featuredImg && (
              <div
                className="ag-institutional__featured-img"
                style={{ backgroundImage: `url('${featuredImg}')` }}
                aria-hidden="true"
              />
            )}
            <div className="ag-institutional__featured-text">
              {data.badge && (
                <span className="ag-institutional__badge">{data.badge}</span>
              )}
              {data.title && (
                <h2 className="ag-institutional__title">{data.title}</h2>
              )}
              {data.description && (
                <p className="ag-institutional__description">{data.description}</p>
              )}
              {data.ctaHref && data.ctaLabel && (
                <UniversalLink
                  href={data.ctaHref}
                  className="ag-institutional__cta-btn"
                >
                  {data.ctaLabel}
                </UniversalLink>
              )}
            </div>
          </div>
        )}
        {cards.length > 0 && (
          <div
            className="ag-institutional__cards"
            style={{ '--ag-cards-cols': cards.length }}
          >
            {cards.map((it, i) => (
              <Card key={i} item={it} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

InstitutionalView.propTypes = {
  data: PropTypes.shape({
    badge: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    ctaLabel: PropTypes.string,
    ctaHref: PropTypes.string,
    featuredImage: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
    featuredImageUrl: PropTypes.string,
    cards: PropTypes.array,
  }).isRequired,
};

export default InstitutionalView;
